import styled from 'styled-components'
import { giphyGrey } from 'shared/css/colors.css'

export default styled.p`
    color: ${giphyGrey};
    line-height: 1.4;
    margin-bottom: 30px;

    a {
        color: ${(props) => props.theme.primaryColor};
        text-decoration: underline;
    }
`
